import moment from 'moment'

export const actionNames = {
  INIT_WEBINAR: 'WEBINAR:INIT_WEBINAR',
  CONNECT_TO_WEBINAR: 'WEBINAR:CONNECT_TO_WEBINAR',
  TWILIO_CONNECTED: 'WEBINAR:TWILIO_CONNECTED',
  TWILIO_DISCONNECTED: 'WEBINAR:TWILIO_DISCONNECTED',
  TWILIO_RECONNECTING: 'WEBINAR:TWILIO_RECONNECTING',
  TWILIO_RECONNECTED: 'WEBINAR:TWILIO_RECONNECTED',
  PARTICIPANT_JOINED: 'WEBINAR:PARTICIPANT_JOINED',
  PARTICIPANT_LEAVING: 'WEBINAR:PARTICIPANT_LEAVING',
  TRACK_ADDED: 'WEBINAR:TRACK_ADDED',
  TRACK_REMOVED: 'WEBINAR:TRACK_REMOVED',
  TRACK_MUTED: 'WEBINAR:TRACK_MUTED',
  TRACK_UNMUTED: 'WEBINAR:TRACK_UNMUTED',
  LOCAL_TRACK_ADDED: 'WEBINAR:LOCAL_TRACK_ADDED',
  LOCAL_TRACK_REMOVED: 'WEBINAR:LOCAL_TRACK_REMOVED',
  SCREEN_SHARING_STOPPED: 'WEBINAR:SCREEN_SHARING_STOPPED',
  FETCH_CONNECTION_INFO_SUCCESS: 'WEBINAR:FETCH_CONNECTION_INFO_SUCCESS',
  SELECT_STREAM_FOR_BROADCAST: 'WEBINAR:SELECT_STREAM_FOR_BROADCAST',
  BROADCAST_STREAMING_STARTED: 'WEBINAR:BROADCAST_STREAMING_STARTED',
  BROADCAST_STREAMING_START_FAILED: 'WEBINAR:BROADCAST_STREAMING_START_FAILED',
  BROADCAST_STREAMING_STOPPED: 'WEBINAR:BROADCAST_STREAMING_STOPPED',
  WEBINAR_INFO_FETCH_SUCCESS: 'WEBINAR:WEBINAR_INFO_FETCH_SUCCESS',
  WEBINAR_INFO_FETCH_FAILED: 'WEBINAR:WEBINAR_INFO_FETCH_FAILED',
  FETCH_PRESENTERS_DATA_SUCCESS: 'WEBINAR:FETCH_PRESENTERS_DATA_SUCCESS',
  FETCH_PRESENTERS_DATA_FAIL: 'WEBINAR:FETCH_PRESENTERS_DATA_FAIL',
  FETCH_LIVE_DATA_SUCCESS: 'WEBINAR:FETCH_LIVE_DATA_SUCCESS',
  LIVE_TOGGLE: 'WEBINAR:LIVE_TOGGLE',
  LIVE_TOGGLE_SUCCESS: 'WEBINAR:LIVE_TOGGLE_SUCCESS',
  LIVE_TOGGLE_FAILURE: 'WEBINAR:LIVE_TOGGLE_FAILURE',
  VOLUME_LEVELS_UPDATED: 'WEBINAR:VOLUME_LEVELS_UPDATED',
  SIGNALING_SERVICE_INITIALIZED: 'WEBINAR:SIGNALING_SERVICE_INITIALIZED',
  TOGGLE_END_WEBINAR_CONFIRM_VISIBILITY:
    'WEBINAR:TOGGLE_END_WEBINAR_CONFIRM_VISIBILITY',
  RECORDING_FAILED: 'WEBINAR:RECORDING_FAILED',
  RECORDING_STARTED: 'WEBINAR:RECORDING_STARTED',
  TOGGLE_WEBINAR_OVER_OVERLAY: 'WEBINAR:TOGGLE_WEBINAR_OVER_OVERLAY',
  LIVE_PROFILING_DATA_ARRIVED: 'WEBINAR:LIVE_PROFILING_DATA_ARRIVED',
  TOGGLE_DEBUG_PROFILING_FREEZE: 'WEBINAR:TOGGLE_DEBUG_PROFILING_FREEZE',
  SIMULATE_DISCONNECT: 'WEBINAR:SIMULATE_DISCONNECT',
  SIMULATE_HEADLESS_DISCONNECT: 'WEBINAR:SIMULATE_HEADLESS_DISCONNECT',
  HEADLESS_HIDDEN_STATE_UPDATED: 'WEBINAR:HEADLESS_HIDDEN_STATE_UPDATED',
  HEADLESS_LEFT: 'WEBINAR:HEADLESS_LEFT',
  HEADLESS_REJOINED: 'WEBINAR:HEADLESS_REJOINED',
  ENDING_WEBINAR: 'WEBINAR:ENDING_WEBINAR',
  FETCH_SCHEDULE_SUCCESS: 'WEBINAR:FETCH_SCHEDULE_SUCCESS',
  LIVE_COUNTDOWN_ZERO: 'WEBINAR:LIVE_COUNTDOWN_ZERO',
  DEVICES_CHANGED: 'WEBINAR:DEVICES_CHANGED',
  TOGGLE_FACING_MODE: 'WEBINAR:TOGGLE_FACING_MODE',
  TOGGLE_FACING_MODE_SUCCESS: 'WEBINAR:TOGGLE_FACING_MODE_SUCCESS',
  CRITICAL_ERROR_OCCURED: 'WEBINAR:CRITICAL_ERROR_OCCURED',
  MONITORING_WARNING_OPENED: 'WEBINAR:MONITORING_WARNING_OPENED',
  MONITORING_WARNING_CLOSED: 'WEBINAR:MONITORING_WARNING_CLOSED',
  MONITORING_WARNING_MUTED: 'WEBINAR:MONITORING_WARNING_MUTED',
  PRESENTER_QUALITY_UPDATED: 'WEBINAR:PRESENTER_QUALITY_UPDATED',
  SECOND_CAMERA_TRIGGERED: 'WEBINAR:SECOND_CAMERA_TRIGGERED',
  SECOND_CAMERA_FETCH_CODE_SUCCESS: 'WEBINAR:SECOND_CAMERA_FETCH_CODE_SUCCESS',
  SECOND_CAMERA_FETCH_CODE_ERROR: 'WEBINAR:SECOND_CAMERA_FETCH_CODE_ERROR',
  HIDE_SECOND_CAMERA_MODAL: 'WEBINAR:HIDE_SECOND_CAMERA_MODAL',
  HIDE_CONNECTING_MODAL: 'WEBINAR:HIDE_CONNECTING_MODAL',
  RECONNECT_STREAMING: 'WEBINAR:RECONNECT_STREAMING',
  RECONNECT_STREAMING_SUCCESS: 'WEBINAR:RECONNECT_STREAMING_SUCCESS',
  SHOW_PERMISSIONS_HINT: 'WEBINAR:SHOW_PERMISSIONS_HINT',
  PERMISSIONS_GRANTED: 'WEBINAR:PERMISSIONS_GRANTED',
  FETCH_WEBINAR_OVER_METRICS: 'WEBINAR:FETCH_WEBINAR_OVER_METRICS',
  FETCH_WEBINAR_OVER_METRICS_SUCCESS:
    'WEBINAR:FETCH_WEBINAR_OVER_METRICS_SUCCESS',
  FETCH_WEBINAR_OVER_METRICS_ERROR: 'WEBINAR:FETCH_WEBINAR_OVER_METRICS_ERROR',
  REDIRECT_TO_MANAGE_PAGE: 'WEBINAR:REDIRECT_TO_MANAGE_PAGE',
  WEBINAR_ENDED: 'WEBINAR:WEBINAR_ENDED',
  GEAR_MODE_PREVIEW_INITIALIZED: 'WEBINAR:GEAR_MODE_PREVIEW_INITIALIZED',
  RAISE_NOTIFICATION: 'WEBINAR:RAISE_NOTIFICATION',
  UPDATE_LIVE_PREVIEW: 'WEBINAR:UPDATE_LIVE_PREVIEW',
  UPDATE_CONNECTING_MODAL_TEXT: 'WEBINAR:UPDATE_CONNECTING_MODAL_TEXT',
  PERSIST_MUTING_SETTINGS: 'WEBINAR:PERSIST_MUTING_SETTINGS',
  AFTER_PLAYBACK_MUTING_SETTINGS_RESTORED:
    'WEBINAR:AFTER_PLAYBACK_MUTING_SETTINGS_RESTORED',
  OVERLAY_UPDATED: 'WEBINAR:OVERLAY_UPDATED',
  SHOW_SPEAKER_OVERLAY: 'WEBINAR:SHOW_SPEAKER_OVERLAY',
  HIDE_SPEAKER_OVERLAY: 'WEBINAR:HIDE_SPEAKER_OVERLAY',
  TOGGLE_QUESTION_OVERLAY: 'WEBINAR:TOGGLE_QUESTION_OVERLAY',
  SHOW_QUESTION_OVERLAY: 'WEBINAR:SHOW_QUESTION_OVERLAY',
  SHOW_CORNER_TAG_OVERLAY: 'WEBINAR:SHOW_CORNER_TAG_OVERLAY',
  HIDE_CORNER_TAG_OVERLAY: 'WEBINAR:HIDE_CORNER_TAG_OVERLAY',
  CORNER_TAG_OVERLAY_TOGGLED: 'WEBINAR:CORNER_TAG_OVERLAY_TOGGLED',
  TOGGLE_POLL_OVERLAY: 'WEBINAR:TOGGLE_POLL_OVERLAY',
  FETCH_SPEAKERS_SUCCESS: 'WEBINAR:FETCH_SPEAKERS_SUCCESS',

  /**
   * List of action names for the Twilio 2.0 upgrade
   */
  SET_PARTICIPANT_IDS: 'WEBINAR:SET_PARTICIPANT_IDS',
}

export const initWebinar = (options) => {
  return {
    type: actionNames.INIT_WEBINAR,
    options,
  }
}

export const selectStreamForBroadcast = (elmVideo, trackId, participantId) => {
  return {
    type: actionNames.SELECT_STREAM_FOR_BROADCAST,
    elmVideo,
    trackId,
    participantId,
  }
}

export const onLiveToggle = (isActive) => {
  return {
    type: actionNames.LIVE_TOGGLE,
    isActive,
    momentDate: moment(),
  }
}

export const toggleEndWebinarConfirmVisibility = (isVisible) => {
  return {
    type: actionNames.TOGGLE_END_WEBINAR_CONFIRM_VISIBILITY,
    isVisible,
  }
}

export const toggleWebinarOverOverlay = () => {
  return {
    type: actionNames.TOGGLE_WEBINAR_OVER_OVERLAY,
  }
}

export const toggleDebugProfilingFreeze = () => {
  return {
    type: actionNames.TOGGLE_DEBUG_PROFILING_FREEZE,
  }
}

export const simulateDisconnect = () => {
  return {
    type: actionNames.SIMULATE_DISCONNECT,
  }
}

export const simulateHeadlessDisconnect = (reason) => {
  return {
    type: actionNames.SIMULATE_HEADLESS_DISCONNECT,
    reason,
  }
}

export const onLiveCountdownZero = () => {
  return {
    type: actionNames.LIVE_COUNTDOWN_ZERO,
  }
}

export const secondCameraTriggered = () => {
  return {
    type: actionNames.SECOND_CAMERA_TRIGGERED,
  }
}

export const hideSecondCameraModal = () => {
  return {
    type: actionNames.HIDE_SECOND_CAMERA_MODAL,
  }
}

export const toggleFacingMode = () => {
  return {
    type: actionNames.TOGGLE_FACING_MODE,
  }
}

export const redirectToManagePage = () => {
  return {
    type: actionNames.REDIRECT_TO_MANAGE_PAGE,
  }
}

export const toggleQuestionOverlay = (question) => {
  return {
    type: actionNames.TOGGLE_QUESTION_OVERLAY,
    question,
  }
}

export const togglePollOverlay = (poll) => {
  return {
    type: actionNames.TOGGLE_POLL_OVERLAY,
    poll,
  }
}

export const setParticipantIds = (participantIds) => {
  return {
    type: actionNames.SET_PARTICIPANT_IDS,
    participantIds,
  }
}

export const fetchScheduleSuccess = (schedule) => {
  return {
    type: actionNames.FETCH_SCHEDULE_SUCCESS,
    schedule,
  }
}
